// extracted by mini-css-extract-plugin
export var footer = "_mc-0";
export var inherit = "_mc-1";
export var input = "_mc-2";
export var modalContent = "_mc-3";
export var quillEditor = "_mc-4";
export var subtitle = "_mc-5";